import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { IauiBettingLimitAction } from "./iaui-betting-limit.action";
import { IauiBettingLimitModalState, IauiBettingLimitState } from "./iaui-betting-limit.model";

const INITIAL_STATE: IauiBettingLimitState = {
	modalState: IauiBettingLimitModalState.CLOSED,
	isModalShown: false,
};

export const iauiBettingLimitReducer = createReducer(
	INITIAL_STATE,
	on(IauiBettingLimitAction.openModal, (state) =>
		updateState(state, {
			modalState: IauiBettingLimitModalState.OPEN,
			isModalShown: true,
		})
	),
	on(IauiBettingLimitAction.closeModal, (state) =>
		updateState(state, {
			modalState: IauiBettingLimitModalState.CLOSED,
		})
	)
);
